import { useState } from 'react'

import Modal from '@components/Modal'

import VehicleForm from 'dashboard-vehicles/components/VehicleForm'
import Button from '@components/Button'
import { withTranslate } from '@i18n/utils'

const VehicleFormModalComponent = () => {
    const [open, setOpen] = useState(false)

    const closeModal = () => {
        const modals = document.getElementsByClassName('modal-dropdown')
        if (modals.length === 1) {
            setOpen(false)
        }
    }

    return (
        <>
            <Button
                className="ml-0 booking__select__button"
                size="small"
                btnStyle="link"
                iconLeft="plus-round"
                onClick={() => setOpen(true)}>
                <T>dashboard.vehicles.add.label</T>
            </Button>
            {open && (
                <Modal onClose={closeModal} header={<T>dashboard.vehicles.add.label</T>}>
                    <VehicleForm onSuccess={() => setOpen(false)} />
                </Modal>
            )}
        </>
    )
}

const VehicleFormModal = withTranslate(VehicleFormModalComponent)

export default VehicleFormModal
